import _ from 'underscore';

function HOClaimExtension(claim) {
    if (claim && claim.lobs && claim.lobs.homeowners) {
        _.extend(this, claim.lobs.homeowners);
    }
}

export default HOClaimExtension;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ho/models/HOClaimExtension.js
// module id = 1554
// module chunks = 0